export const VIEW_STUDENT_ROOM_MANUAL = "VIEW_STUDENT_ROOM_MANUAL";